const borders: { [index: string]: string } = {
  bd_radius_default: '6px',
  bd_radius_small: '4px',
  bd_radius_large: '8px',
};
export default borders;
